import { StrictOmit } from "../../../../../lib/lang"

export enum LanguageCode {
    EN = "en",
    DA = "da",
}

export enum TermsAndConditionsType {
    POS = "POS",
    ECOM = "ECOM",
}

export type CreatedType = Readonly<{
    timestamp: string
    author: string
}>

export type TermsAndConditionsHistory = Readonly<{
    created: CreatedType
    updated: CreatedType
}>

export type TermsAndConditionsItem = Readonly<{
    id: number
    type: TermsAndConditionsType
    languageCode: LanguageCode
    version: number
    callName: string
    isActive: boolean
}>

export type TermsAndConditions = Readonly<{
    id: number
    type: TermsAndConditionsType
    languageCode: LanguageCode
    version: number
    callName: string
    isActive: boolean
    text: string
    history: TermsAndConditionsHistory
}>

export type CreateTermsAndConditions = StrictOmit<TermsAndConditions, "id" | "version" | "history"> &
    Readonly<{
        supplier: {
            id: number
        }
    }>

export type UpdateTermsAndConditions = StrictOmit<CreateTermsAndConditions, "supplier">

export type TermsAndConditionsFormValues = Readonly<{
    type: TermsAndConditionsType | ""
    languageCode: LanguageCode
    callName: string
    isActive: boolean
    text: string
}>
